module.exports = __webpack_public_path__ + "img/1-21.ae5fbbe6.jpg";